import produce from 'immer';
import margeById from '../../helpers/margeById';

export const actions = {
  /**
   * Action that fire/trigger redux-saga watchers
   */

  GET_ARTISAN_STATS: 'GET_ARTISAN_STATS',
  GET_SUPPLIER_STATS: 'GET_SUPPLIER_STATS',
  GET_ADMIN_STATS: 'GET_ADMIN_STATS',
  GET_SUPER_STATS: 'GET_SUPER_STATS',
  GET_CUSTOMER_STATS: 'GET_CUSTOMER_STATS',

  /**
   * Actions that are fired BY redux-saga watchers after a response
   */

  GET_ARTISAN_STATS_SUCCESS: 'GET_ARTISAN_STATS_SUCCESS',
  GET_SUPPLIER_STATS_SUCCESS: 'GET_SUPPLIER_STATS_SUCCESS',
  GET_ADMIN_STATS_SUCCESS: 'GET_ADMIN_STATS_SUCCESS',
  GET_SUPER_STATS_SUCCESS: 'GET_SUPER_STATS_SUCCESS',
  GET_CUSTOMER_STATS_SUCCESS: 'GET_CUSTOMER_STATS_SUCCESS',

  /**
   * Misc
   */
  SET_STATS_IS_LOADING: 'SET_STATS_IS_LOADING'
};

const initialState = {
  artisanStats: {},
  supplierStats: {},
  superStats: {},
  adminStats: {},
  customerStats: {},
  isLoading: false
};

export default produce((draft, action) => {
  const { type, payload } = action;

  if (!draft) {
    return initialState;
  }

  switch (type) {
    case actions.GET_ARTISAN_STATS_SUCCESS: {
      draft.artisanStats = payload;
      break;
    }
    case actions.GET_SUPPLIER_STATS_SUCCESS: {
      draft.supplierStats = payload;
      break;
    }
    case actions.GET_ADMIN_STATS_SUCCESS: {
      draft.adminStats = payload;
      break;
    }
    case actions.GET_SUPER_STATS_SUCCESS: {
      draft.superStats = payload;
      break;
    }
    case actions.GET_CUSTOMER_STATS_SUCCESS: {
      draft.customerStats = payload;
      break;
    }
    /**
     * Misc
     */

    case actions.SET_STATS_IS_LOADING: {
      draft.isLoading = payload;
      break;
    }

    default:
      break;
  }
});
